import { handleActions } from 'redux-actions';

import { setUnreadMessages } from '../actions/unread_messages';

export default handleActions(
  {
    [setUnreadMessages]: (state, { payload: { customer_id, unread } }) => ({
      ...state,
      [customer_id]: unread,
    }),
  },
  {}
);
